type TSeasonAnchor = {
  hash: string;
  query: string;
};

function getSeasonAnchor(season: string): TSeasonAnchor {
  return {
    query: `?season=${season}`,
    hash: `#season=${season}`
  };
}

export { getSeasonAnchor };
